import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SearchRequest } from '../program-work/search-request.model';
import { SearchResult } from '../program-work/search-result.model';

@Injectable({providedIn: 'root'})
export class Rail360ViewService {

	private url: string;

	constructor(private httpClient: HttpClient) {
		this.url = 'api/Dashboard';
	}

	public search(searchText: SearchRequest): Observable<SearchResult> {
		return this.httpClient.post<SearchResult>(this.url + '/search', searchText);
	}
}
